import styled from "styled-components";
export const StatsList = styled.ul`


list-style-type: none;
margin:30px 0 auto 0;
padding:0;
display:flex;

justify-content: space-between;

`
export const StatsItem = styled.li`
    display:flex;
    flex-direction: column;
    text-align:center;
`